import actionTypes from './actionTypes';

export const setAwsConnectionStatus = (status, error = {}) => ({
  type: actionTypes.setAwsConnectionStatus,
  status: status,
  error: error,
});

export const setAwsConnectionStatusSuccess = () => ({
  type: actionTypes.setAwsConnectionStatus,
  status: 'Success',
});

export const setAwsConnectionStatusError = (error = {}) => ({
  type: actionTypes.setAwsConnectionStatus,
  status: 'Error',
  error: error,
});

export const setDisplayOnlyRequiredInfoFields = (value) => ({
  type: actionTypes.setDisplayOnlyRequiredInfoFields,
  value: value,
});

export const setCurrentTrialName = (value) => ({
  type: actionTypes.setCurrentTrialName,
  value: value,
});

export const setCurrentLibraryId = (value) => ({
  type: actionTypes.setCurrentLibraryId,
  value: value,
});

export const setCurrentLibraryName = (value) => ({
  type: actionTypes.setCurrentLibraryName,
  value: value,
});

export const setCurrentCollectionId = (value) => ({
  type: actionTypes.setCurrentCollectionId,
  value: value,
});

export const setCurrentCollectionName = (value) => ({
  type: actionTypes.setCurrentCollectionName,
  value: value,
});

export const setAuthenticityToken = (token) => ({
  type: actionTypes.setAuthenticityToken,
  token: token,
});

export const setNotificationDomRef = (notificationDomRef) => ({
  type: actionTypes.setNotificationDomRef,
  notificationDomRef: notificationDomRef,
});

export const setConfirmDialogCompleted = (value) => ({
  type: actionTypes.setConfirmDialogCompleted,
  value: value,
});

export const setActiveAccordionIndex = (fileIndex) => ({
  type: actionTypes.setActiveAccordionIndex,
  fileIndex: fileIndex,
});

export const addHeartbeatId = (fileIndex, heartbeatId) => ({
  type: actionTypes.addHeartbeatId,
  payload: {
    fileIndex,
    heartbeatId,
  },
});

export const removeHeartbeatId = (fileIndex) => ({
  type: actionTypes.removeHeartbeatId,
  fileIndex: fileIndex,
});
